<bee-share [isOpen]="moi.settings.content.isOpen" [settings]="moi.settings.content.shareSettings"></bee-share>